// Google tag (GA4 + Google Ads) is loaded in public/index.html.
const ADS_ID = 'AW-18460691572';

// Conversion labels from Google Ads → Goals → Conversions → (action) → Tag setup.
// The label is the part after the slash in `send_to: 'AW-18460691572/XXXX'`.
// Leave empty to send the GA4 event only (it can still be imported into Ads from GA4).
const ADS_LABELS = {
  extension_install: '2AWYCLS4p4EdEPSY3-JE',
  chrome_store_click: '',
  ios_click: '',
  android_click: '',
};

const STORE_EVENTS = [
  ['chrome.google.com/webstore', 'chrome_store_click'],
  ['chromewebstore.google.com', 'chrome_store_click'],
  ['microsoftedge.microsoft.com', 'edge_store_click'],
  ['addons.mozilla.org', 'firefox_store_click'],
  ['apps.apple.com', 'ios_click'],
  ['play.google.com', 'android_click'],
];

const GCLID_KEY = 'hv_gclid';

export const track = (event, params = {}) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', event, params);
  const label = ADS_LABELS[event];
  if (label) {
    window.gtag('event', 'conversion', { send_to: `${ADS_ID}/${label}` });
  }
};

const cameFromAds = () => {
  try {
    if (new URLSearchParams(window.location.search).has('gclid')) {
      sessionStorage.setItem(GCLID_KEY, '1');
    }
    return sessionStorage.getItem(GCLID_KEY) === '1';
  } catch {
    return false;
  }
};

// Tags Chrome Web Store links so CWS Analytics can attribute installs to Ads.
const addStoreUtm = (link) => {
  const url = new URL(link.href);
  if (url.searchParams.has('utm_source')) return;
  const fromAds = cameFromAds();
  url.searchParams.set('utm_source', fromAds ? 'google' : 'highvocab.com');
  url.searchParams.set('utm_medium', fromAds ? 'cpc' : 'referral');
  url.searchParams.set('utm_campaign', 'landing');
  link.href = url.toString();
};

// One delegated listener covers every store link on the site.
export const initStoreClickTracking = () => {
  cameFromAds();
  document.addEventListener(
    'click',
    (e) => {
      const link = e.target.closest && e.target.closest('a[href]');
      if (!link) return;
      const match = STORE_EVENTS.find(([host]) => link.href.includes(host));
      if (!match) return;
      const event = match[1];
      if (event === 'chrome_store_click') addStoreUtm(link);
      track(event, { link_url: link.href, page_path: window.location.pathname });
    },
    true,
  );
};
